import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';
import TagsToolContent from '../TagsToolContent';
import TagEditPopup from './TagEditPopup';
import useTagPopupsState from '../useTagPopupsState';
import { closePopup } from '../../../../../../components/popupPanel/popupActions';

import { TooltipAlignment } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { Tag } from '../../../../../../../common/tags/tagTypes';

import './TagsToolbarPopup.scss';

export type TagsToolbarPopupProps = {
    name: string;
    buttonSelector: string;
    alignment: TooltipAlignment;
    currentUserId: string;
    currentBoardId: string;
    selectedElements: Immutable.List<ImMNElement>;
    tag: Tag | null;
    showEditingPopup: boolean;
    shareRootPath: Array<ImMNElement>;
    userRootPath: Array<ImMNElement>;
    handleClickEdit: (tag: Tag) => void;
    closePopup: () => void;
};

const TagsToolbarPopup: React.FC<TagsToolbarPopupProps> = (props) => {
    const { buttonSelector } = props;

    const [showEditingPopup, setShowEditingPopup] = useState<boolean>(false);
    const openEditingPopup = () => {
        setShowEditingPopup(true);
    };

    const tagProps = useTagPopupsState(openEditingPopup);
    const { currentlyEditingTag, setCurrentlyEditingTagId, shareRootPath } = tagProps;

    const dispatch = useDispatch();
    const dismissPopup = () => {
        dispatch(closePopup(PopupIds.TAG_EDIT_MENU, false));
        setShowEditingPopup(false);
        setCurrentlyEditingTagId(null);
    };

    return (
        <ToolbarPopup
            buttonSelector={buttonSelector}
            alignment={TooltipAlignment.CENTER}
            popupId={PopupIds.TAGS_TOOL}
            className={classNames('TagsPopup')}
            showArrow={false}
        >
            <TagsToolContent {...props} {...tagProps} />
            <TagEditPopup
                tag={currentlyEditingTag}
                showEditingPopup={showEditingPopup}
                shareRootPath={shareRootPath}
                closePopup={dismissPopup}
            />
        </ToolbarPopup>
    );
};

export default TagsToolbarPopup;
